import { createSlice } from "@reduxjs/toolkit";
import { verifyOtp } from "../../reducer/verifyOtp/verifyOtpReducer";

import i18n from "../../i18n";
const initialState = {
  data: {},
  isLoading: false,
  error: null,
};

const verifyOtpSlice = createSlice({
  name: "verifyOtp",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(verifyOtp.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(verifyOtp.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload; // same like login
        state.error = null;
      })
      .addCase(verifyOtp.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error?.message || i18n.t("toast.failedToVerifyOtp");
      });
  },
});

export default verifyOtpSlice.reducer;
